import { postMetaConverter } from '@shared/services/meta';
import { PAYMENTS_HOTELS } from '@shared/helpers/routes';

import baseBookingSchema from './formBaseBookingSchema';

import * as Yup from 'yup';

export const getFieldErrorNames = formikErrors => {
  const result = [];

  const transformObjectToDotNotation = (obj, prefix = '') => {
    Object.entries(obj).forEach(([key, value]) => {
      if (value && typeof value === 'object') {
        transformObjectToDotNotation(
          value,
          `${prefix}${prefix ? `[${key}]` : key}`
        );
      } else if (value) {
        result.push(`${prefix}${prefix ? `[${key}]` : key}`);
      }
    });
  };

  transformObjectToDotNotation(formikErrors);

  return result;
};

export const toNextStep = ({
  search,
  hotelDetails,
  values,
  location,
  user,
  paxDetails,
  history,
  detailTransaction,
  id_integration,
  baseBookingBody,
  subsidiary,
  seller,
  storageKey,
  id_provider,
  urlToken,
  room,
  hotelCode,
  id_hotel,
  idCity,
  price,
  cancelationFee,
  validate,
}) => {
  window.dataLayer.push({
    event: 'datosPersonalesHotel',
    eventProps: {
      category: 'formulario',
      action: 'submit',
      label: 'continuar',
      value: {
        pasajeros: values.passengers,
        hotel: hotelDetails,
        datos_contacto: {
          email: values.email,
          telefono: values.phone,
        },
      },
    },
  });
  postMetaConverter(
    {
      event_name: 'datosPersonalesHotel',
      custom_data: {
        category: 'formulario',
        action: 'submit',
        label: 'continuar',
        pasajeros: values.passengers,
        hotel: hotelDetails,
        datos_contacto_email: values.email,
        datos_contacto_telefono: values.phone,
      },
    },
    user
  );
  history.push({
    pathname: PAYMENTS_HOTELS,
    state: {
      baseBookingBody,
      detailTransaction,
      id_integration,
      passengerDetails: paxDetails,
      user,
      hotelDetails,
      search,
      refundable: location.state.refundable,
      subsidiary,
      seller,
      storageKey,
      id_provider,
      urlToken,
      room,
      hotelCode,
      id_hotel,
      idCity,
      price,
      cancelationFee,
      validate,
      id_product: validate.id_product,
    },
  });
};

const setRooms = room => {
  return room.rooms.map((item, i) => {
    const baseRoom = {
      id_room_type: item.id_room_type,
      sequence: i + 1,
      room: item.description,
      rate_id: item.rate_id ?? null,
      rph: item.rph ? String(item.rph) : null,
    };

    if (room?.board?.code) {
      baseRoom.board_code = room.board.code;
    }

    return baseRoom;
  });
};

function getString(value) {
  return value == null ? null : String(value);
}

function normalizeHotelInfo(hotelDetails, search) {
  let rating = null;
  const rawRating = hotelDetails?.rating;

  if (rawRating != null && !Number.isNaN(Number(rawRating))) {
    rating = Number(rawRating);
  }

  const searchCity =
    search?.search_option?.option?.reference_city ??
    search?.search_option?.option;

  return {
    phone: getString(hotelDetails?.telephones?.[0]),
    rating: rating,
    city: getString(searchCity?.city),
    country: getString(searchCity?.country),
    name: getString(hotelDetails?.name),
  };
}

export const buildBaseBookingBody = ({
  search,
  hotelDetails,
  idCity,
  formik,
  seller,
  user,
  paxValues,
  paxDetails,
  room,
  id_product,
  supplier_code,
  validate,
  id_provider,
  id_hotel,
}) => {
  const rooms = setRooms(room);

  const hotel_info = normalizeHotelInfo(hotelDetails, search);

  const baseBookingBody = {
    id_product,
    supplier_code,
    checkIn: search.checkIn,
    checkOut: search.checkOut,
    hotel_address: hotelDetails?.location?.address,
    meal_plan: room?.board?.description,
    id_hotel,
    id_city: idCity || null,
    passenger_email: formik.values.emailValidation,
    comments: formik.values.comments,
    phone: formik.values.phone,
    supplier: validate?.supplier,
    providers: +id_provider,
    user_id: user?.id || null,
    passangers: paxValues,
    passangerDetails: paxDetails,
    rooms,
    hotel_info,
    id_assigned_seller: seller?.id_user ?? null,
  };

  return { baseBookingBody };
};

export const returnFormValidator = (search, payee, ID_SITE_CONST) => {
  if (+ID_SITE_CONST === 3) {
    return baseBookingSchema(search);
  }

  return baseBookingSchema(search).concat(
    Yup.object().shape({
      id_entity: Yup.string().test(
        'required-if-pos',
        'Debes seleccionar un punto de venta',
        function (value) {
          return payee.isPointOfSale ? !!value : true;
        }
      ),
      id_assigned_seller: Yup.string().test(
        'required-if-not-pos',
        'Debes seleccionar un vendedor',
        function (value) {
          return payee.isPointOfSale ? true : !!value;
        }
      ),
    })
  );
};
